import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Scharnier from "../../doors/scharnier";
import Paneel from "../../doors/paneel";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import { frameSettings } from "shared/utils/doorConfigurations";

interface SingleScharnierDoublePanelSingleScharnierProps
  extends ConfigurationProps {}
const SingleScharnierDoublePanelSingleScharnier: React.FC<
  SingleScharnierDoublePanelSingleScharnierProps
> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: SingleScharnierDoublePanelSingleScharnierProps) => {
  const position0 = new Vector3(-0.495, 0, 0);
  const position1 = new Vector3(0.459, 0, 0);
  const position2 = new Vector3(1.377, 0, 0);
  const position3 = new Vector3(2.295, 0, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(
      getConfigurationPositions([position0, position1, position2, position3])
    );
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <Scharnier
        materials={materials}
        position={positions[0]}
        rotation={rotation}
        index={0}
        frameSettings={doorSettings?.main?.frameSettings}
        lockSettings={doorSettings?.main?.lockSettings}
      />
      <Paneel materials={materials} position={positions[1]} index={1} />
      <Paneel materials={materials} position={positions[2]} index={2} />
      <Scharnier
        materials={materials}
        position={positions[3]}
        index={3}
        frameSettings={doorSettings?.tertiary?.frameSettings}
        lockSettings={doorSettings?.tertiary?.lockSettings}
      />
    </group>
  );
};

export default SingleScharnierDoublePanelSingleScharnier;
